import { OrderedMap } from 'immutable';
import FileEntity from 'entities/File';
import { UploadRequestData } from 'reducers/fileUploads';

declare var __webpack_public_path__: string;

function makeStripExifWorker(): Worker {
  const appPublicPath = __webpack_public_path__; // eslint-disable-line
  // XXX to load the web worker from the same origin. In prod, Webpack public
  // path is a CDN on a different origin which violates web worker security
  // model.
  __webpack_public_path__ = '/assets/'; // eslint-disable-line
  const Worker = require('./fileUploadExifStripper.worker.js');
  // Can't type this properly since worker-loader works differently from other Webpack loaders and Flow can't detect that
  // $FlowIssue Constructor cannot be called on exports
  const worker = new Worker();
  __webpack_public_path__ = appPublicPath; // eslint-disable-line
  return worker;
}

export function uploadFile(
  fileContextKey: string,
  file: File,
  uploadRequest: (
    fileContextKey: string,
    filename: string,
    blob: File,
    privateUpload: boolean
  ) => void,
  loadThumbnail?: (fileContextKey: string, filename: string, thumbnail: string) => void,
  privateUpload: boolean = false
) {
  if (loadThumbnail && file.type.startsWith('image')) {
    const fileReader = new FileReader();
    fileReader.onload = onLoadEvent => {
      loadThumbnail(fileContextKey, file.name, (onLoadEvent.target as FileReader).result as string);
    };
    fileReader.readAsDataURL(file);
  }
  if (file.type === 'image/jpeg') {
    const fileReader = new FileReader();
    fileReader.onload = onLoadEvent => {
      const worker = makeStripExifWorker();
      worker.addEventListener('message', (e: MessageEvent) => {
        if ((e instanceof MessageEvent && e.data && typeof e.data.data === 'string') === false) {
          throw new Error('unexpected message type from ExifStripper worker');
        }

        const { data, error } = e.data;
        if (error) {
          // Log the error so we can see when this happens
          console.warn(error.originalError, error.stack);
          console.error(error.message);
        }
        const dataURItoBlob = require('data-uri-to-blob');
        // IE doesn't have a File constructor, so just upload a blob with a name
        const blob = dataURItoBlob(data);
        blob.name = file.name;
        uploadRequest(fileContextKey, blob.name, blob, privateUpload);
      });
      worker.postMessage((onLoadEvent.target as FileReader).result);
    };
    fileReader.readAsDataURL(file);
  } else {
    uploadRequest(fileContextKey, file.name, file, privateUpload);
  }
}

export function getFilesArrayFromFileUploads(
  fileUploads: OrderedMap<string, UploadRequestData>
): FileEntity[] {
  const files = fileUploads.valueSeq();
  // DEBUG UNTIL https://my.trackjs.com/messages/filtered?hash=6220d602465d6b16
  const entities = files
    .map(uploadRequestData => uploadRequestData && uploadRequestData.file)
    .filter(Boolean)
    .filter(f => f instanceof FileEntity)
    .toArray() as FileEntity[];
  if (files.size !== entities.length) {
    console.warn({ fileUploads, entities });
    console.error('invalid value in fileUploads map');
  }
  return entities;
}

export function getFirstFileId(
  fileUploads: OrderedMap<string, UploadRequestData>
): string | undefined {
  return fileUploads.keySeq().first();
}

export function getFirstFile(
  fileUploads: OrderedMap<string, UploadRequestData>
): UploadRequestData | undefined {
  const firstFileId = getFirstFileId(fileUploads) || '';
  return fileUploads.get(firstFileId);
}
